import * as React from 'react';
import { GridCell } from '@progress/kendo-react-grid';
import { EditSurveyContext } from '../common/context';
import EditIcon from '@material-ui/icons/Edit';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import DropdownMenuComponent from '../common/menu/DropdownMenuComponent';
import * as PropTypes from 'prop-types';

const items = [
    {
        text: 'Edit',
        icon: <EditIcon />,
        customCss: ''
    },
    {
        text: 'Delete',
        icon: <RemoveCircleIcon />,
        customCss: 'popperDropdownDangerMenuItem'
    }
]

export default class EditSurveyButton extends GridCell {
    static contextTypes = {
        router: PropTypes.object
    }

    constructor(props: any, context: any) {
        super(props, context);
        this.handleMenuItem = this.handleMenuItem.bind(this);
    }

    handleMenuItem = (option: any, action: any) => {
        const surveyId = this.props.dataItem.id;
        if (option === 'Edit') {
            this.context.router.history.push(`/survey/${surveyId}`);
        }
        if (option === 'Delete') {
            action.deleteSurvey(surveyId);
        }

    }
    render() {
        let updatedItems: any = [];
        updatedItems = this.props.dataItem.statusText === "Draft" ? items : [
            {
                text: 'Edit',
                icon: <EditIcon />,
                customCss: ''
            }
        ]
        return (
            <EditSurveyContext.Consumer>
                {(value: any) => {
                    return (
                        <td>
                            <DropdownMenuComponent menuItems={updatedItems} action={value} onMenuItemClicked={this.handleMenuItem} />
                        </td>
                    )
                }}
            </EditSurveyContext.Consumer>
        );
    }
}





// WEBPACK FOOTER //
// ./src/components/surveys/EditSurveyButton.tsx